import { ArrowDown2 } from "iconsax-react";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  width: 100%;
`;

export const Label = styled.label`
  width: 100%;
  margin: 0 0 0.5rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.colors?.textColor};
`;

export const Required = styled.span`
  font-family: Inter;
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.checkoutOnePage?.red};
`;

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 100%;

  position: relative;
`;

export const ArrowDown = styled(ArrowDown2)`
  width: 1rem;
  color: ${({ theme }) => theme.checkoutOnePage?.textColor};

  position: absolute;
  right: 1rem;
`;

export const Select = styled.select`
  width: 100%;
  padding: 1rem 1.5rem;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  border-radius: 0.5rem;
  border: 0.094rem solid
    ${({ theme }) => theme.checkoutOnePage?.inputBorderColor};
  color: ${({ theme }) => theme.checkoutOnePage?.textColor};
  background: ${({ theme }) => theme.checkoutOnePage?.inputBackground};

  position: relative;

  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  -ms-progress-appearance: none;

  &::placeholder {
    color: ${({ theme }) => theme.checkoutStepsOffers?.placeholderColor};
  }

  &:disabled {
    opacity: 0.8;
  }

  &:hover {
    border: 0.094rem solid
      ${(props) =>
        `${props.theme?.checkoutStepsOffers?.checkoutPrimaryColor}a0`};
  }

  &:focus {
    border: 0.094rem solid
      ${(props) =>
        `${props.theme?.checkoutStepsOffers?.checkoutPrimaryColor}a8`};
  }
`;

export const Option = styled.option`
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  color: ${({ theme }) => theme.checkoutOnePage?.textColor};
  background: ${({ theme }) => theme.checkoutOnePage?.inputBackground};

  padding: 1rem;

  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  -ms-progress-appearance: none;
`;

export const InvalidMessage = styled.span`
  width: 100%;
  margin: 0.5rem 0 0;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1rem;

  color: ${({ theme }) => theme.checkoutOnePage?.red};
`;

export const WrapperInputs = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;

  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));

  width: 100%;
  margin: 0 0 1rem;

  &:last-child {
    margin: 0;
  }
`;
